<template>
  <div class="options-container">
    <div style="margin:10px 0" v-for="(item, index) in this.options" :key="item.optionId">
      <!--<van-button v-if="index === levelIndex" type="info">{{ item.level }}</van-button>-->
      <div
        class="button-quiz"
        v-if="selectingOption !== item.optionId"
        @click="onOptionSelect(item.optionId)"
      >
        <p>
          <span>{{OPTION_LABELS[index]}}.</span>
          {{item.title }}
        </p>
      </div>
      <div class="button-quiz-select" v-else >
        <span >{{OPTION_LABELS[index]}}.</span>
        {{ item.title }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    options: {
      type: Array,
      default: [],
    },
    selectingOption: {
      type: Number,
      default: 0,
    },
    onOptionSelect: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      OPTION_LABELS: ["A", "B", "C", "D","E", "F", "G", "H"],
    };
  },
  watch:{
      selectingOption(){
          console.log('seselectingOption')
      }
  },
  methods: {
    //   onOptionSelect(item){
    //   }
  },
};
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.options-container {
  flex-wrap: wrap;
  margin: 20px 0;
  padding-bottom: 20px;
}

.button-quiz {
  border: 1px solid #3994E7;
  margin: 10px 0;
  text-align: left;
  padding: 8px 16px;
  font-size: 14px;
  word-wrap: break-word;
  border-radius: 20px;
  color: #333333;
}

.button-quiz-select {
  margin: 10px 0;
  text-align: left;
  padding: 8px 16px;
  font-size: 14px;
  word-wrap: break-word;
  border-radius: 20px;
  color: #ffffff;
  background: linear-gradient(right, #98CEFF, #3994E7);
}
</style>


// WEBPACK FOOTER //
// app/pages/article/component/OptionGroup.vue